<template>
  <div class="product-page--create">
    <v-row no-gutters>
      <v-col cols="12">
        <redirect class="mb-5" title="Collection" route="website.gmc.sync-collections" />
        <div class="page-header">
          <h2 class="page-title">{{ name }}</h2>
        </div>
        <div>
          <v-btn v-if="attributes.published == false" class="mr-3 pointer" @click="attributes.published = true">
            <i class="far fa-eye"></i>
            Enable collection
          </v-btn>
          <v-btn v-else class="mr-3 pointer" @click="attributes.published = false">
            <i class="far fa-eye-slash"></i>
            Disable collection
          </v-btn>
          <v-btn v-if="attributes.published == true" @click="gotoStore" class="pointer">
            <i class="show-password far fa-eye fz-16 mr-1"></i>
            View
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <!-- <GroupSubmit mode="edit" :isLoading="isLoading" :callbackCancel="onCancel" :callbackSubmit="onSubmit" /> -->
    <v-row v-if="!loading">
      <v-col cols="12">
        <Notification type="error" :messages="errors" v-if="errors.length > 0" />
      </v-col>
      <v-col cols="12" sm="8" class="d-flex flex-column">
        <div class="elevation-form pa-3">
          <InputDefault :model="['attributes', 'title']" fieldName="Title" label="Title" :isValidate="true" />

          <ContentInput :v-model="attributes.bodyHtml" title="Description" subtitle="Maximum 100.000 characters" />
        </div>
        <div class="elevation-form pa-3 mt-3">
          <InputDefault
            :model="['attributes', 'metaDescription']"
            fieldName="Title"
            :height="150"
            label="Meta Description"
            :isValidate="true"
            :min="0"
            :max="160"
            typeComponent="metaDes"
          />
        </div>
        <div v-if="attributes.collectionType === 'smart'" class="elevation-form pa-3 mt-3">
          <CollectionType />
        </div>

        <div class="mt-4">
          <v-col cols="12" sm="12" xs="12" class="pa-3 elevation-form">
            <template>
              <v-row justify="center">
                <v-expansion-panels accordion>
                  <v-expansion-panel>
                    <v-expansion-panel-header disable-icon-rotate>
                      <div>
                        <h3>Search engine listing preview</h3>
                        <p class="mt-5">
                          Add a title and description to see how this collection might appear in a search engine listing
                        </p>
                      </div>
                      <template v-slot:actions>
                        <span class="btn-link">Edit website SEO</span>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <template>
                        <div>
                          <span>Page title</span>
                          <v-text-field v-model="attributes.metafieldsGlobalTitleTag"></v-text-field>
                        </div>
                        <div>
                          <span>Meta description</span>
                          <v-textarea v-model="attributes.metafieldsGlobalDescriptionTag"></v-textarea>
                        </div>
                        <div>
                          <span>URL and handle</span>
                          <v-text-field v-model="attributes.metafieldsGlobalUrl" :prefix="domain"></v-text-field>
                        </div>
                      </template>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-row>
            </template>
          </v-col>
        </div>
      </v-col>

      <!-- ########################################################################## RIGHT -->
      <v-col cols="12" sm="4" class="d-flex flex-column">
        <div class="elevation-form pa-3">
          <CollectionAvailability />
        </div>
        <div class="elevation-form pa-3 mt-4">
          <h4 class="mb-3">Collection image</h4>
          <UploadOneImage :image="attributes.image" @callback="getImageUpLoad" />
        </div>
        <div class="elevation-form pa-3 mt-4">
          <h4 class="mb-3">Add collection to navigation</h4>
          <div>
            <span>
              The collection will appear in the selected menu items under Top Navigation
            </span>
          </div>
          <v-select :return-object="true" v-model="menuCollection" multiple :items="menus" item-text="title"></v-select>
          <div>
            <v-chip
              v-for="(i, k) in menuCollection"
              :key="i.title + k"
              class="mb-2 mx-2"
              @click:close="removeChip(k)"
              close
              hide-selected
              small
              label
              multiple
            >
              {{ i.title }}
            </v-chip>
          </div>
          <div @click="$router.push(`/admin/menus`)" class="pointer">
            Edit navigation
          </div>
        </div>
      </v-col>

      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>

      <v-col cols="12" class="d-flex">
        <v-btn @click="showDialogDelete = true" class="mr-3" color="error" elevation="">Delete</v-btn>
        <v-spacer></v-spacer>
        <v-btn outlined class="mr-3" @click="onCancel">Discard</v-btn>
        <v-btn :loading="isLoading" color="primary" @click="onSubmit">Save</v-btn>
      </v-col>
    </v-row>

    <div style="width: 100%; height: 100%" v-if="loading" class="d-flex justify-center align-center">
      <page-loader />
    </div>

    <BeforeLeavePage />
    <delete-action :content="'collection ' + name" :title="'Delete ' + name" />
  </div>
</template>

<script>
import { menuService } from '@/apis/menu.s';
import { imageFake } from '@/const/image';
import imageHelpers from '@/helpers/image';
import utilities from '@/helpers/utilities';
import ContentInput from '@/views/website/components/Editor';
import { maxLength, required } from 'vuelidate/lib/validators';
import { gmcApi } from '../../../../apis/gmc';
import CollectionAvailability from './components/CollectionAvailability';
import CollectionType from './components/CollectionType';

export default {
  components: {
    ContentInput,
    CollectionAvailability,
    CollectionType,
  },
  data() {
    let defaultForm = {
      title: '',
      bodyHtml: null,
      image: {
        src: 'https://miro.medium.com/max/1200/1*mk1-6aYaf_Bes1E3Imhc0A.jpeg',
        position: 1,
      },
      rules: [{ column: 'tags', relation: 'equal', condition: null }], // [{column,relation,condition}]
      collectionType: 'smart',
      handle: '',
      disjunctive: true,
      upsellOffer: true,
      upsellWidget: true,
    };
    return {
      imageFake,
      menuCollection: [],
      listIdProductAddCollection: [],
      isLoadingProduct: false,
      showModalSelectProduct: false,
      imageHelpers,
      collectionType: '',
      showDialogDelete: false,
      name: '',
      idItem: null,
      isLoading: false,
      loading: false,
      // page: {},
      showHeader: false,
      loadingSelect: false,
      attributes: Object.assign({}, defaultForm),
      defaultForm,
      listVariants: [],
      // Product options
      options: [], // need
      productList: [],
      productSelectList: [],
      errors: [],
      validLoadMore: true,
      isLoadingMore: false,
      page: 1,
      filter: '',
      sort: '',
      domain: `${localStorage.getItem(`store-domain`)}/`,

      filters: [
        {
          name: 'Product title A-Z',
          value: 'alphaAsc',
        },
        {
          name: 'Product title Z-A',
          value: 'alphaDesc',
        },
        {
          name: 'Highest price',
          value: 'priceAsc',
        },
        {
          name: 'Lowest price',
          value: 'priceDesc',
        },
        {
          name: 'Newest',
          value: 'createdAsc',
        },
        {
          name: 'Oldest',
          value: 'createdDesc',
        },
        {
          name: 'Manual',
          value: 'manual',
        },
        {
          name: 'Top sales',
          value: 'totalSalesDesc',
        },
      ],
      draggableOptions: { disabled: true },
      selected: [],
      checkAll: false,
      menus: [],
    };
  },
  async created() {
    try {
      this.loading = true;
      this.idItem = this.$route.params.id;
      let res = (await gmcApi.getSyncCollectionById(this.idItem)).data.collection;
      let m = await menuService.getMenuByCollectionId(this.idItem);
      this.menuCollection = m.data;
      console.log(m, 'mmmm');
      this.name = res.title;
      this.attributes = {
        bodyHtml: res.bodyHtml,
        title: res.title,
        image: res.image,
        published: res.published,
        publishedScope: res.publishedScope,
        collectionType: res.collectionType,
        handle: res.handle,
        rules: res.rules,
        metafieldsGlobalTitleTag: res.metafieldsGlobalTitleTag,
        metafieldsGlobalDescriptionTag: res.metafieldsGlobalDescriptionTag,
        metafieldsGlobalUrl: res.metafieldsGlobalUrl,
        disjunctive: res.disjunctive,
        metaDescription: res.metaDescription,
        upsellOffer: res.upsellOffer || res.upsellOffer === undefined ? true : false,
        upsellWidget: res.upsellWidget || res.upsellWidget === undefined ? true : false,
        sortOrder: res.sortOrder,
      };
      this.filter = this.filters.find(filter => filter.value == res.sortOrder)?.value;
      this.draggableOptions.disabled = this.filter == 'manual';
      this.$forceUpdate();
    } catch (error) {
      console.log(error);
    }
    this.loading = false;
    this.getMenus();
  },
  methods: {
    removeChip(k) {
      this.menuCollection.splice(k, 1);
    },
    async getMenus() {
      try {
        let menuData = await menuService.list();
        this.menus = menuData.data;
        console.log(this.menus);
        this.isLoading = false;
      } catch (error) {
        console.log(`error`, error);
        this.errors = error.response.data.message || [];
      }
    },
    gotoStore() {
      window.open('https://' + this.$store.state.auth.accountInfo.rDomain + `/collections/${this.attributes.handle}`);
    },
    async submitDelete() {
      try {
        gmcApi.deleteSyncCollection(this.idItem);
        this.$router.push({ name: 'website.gmc.sync-collections' });
      } catch (error) {
        console.log(error);
      }
    },
    getImageUpLoad(images) {
      this.attributes.image = images;
    },
    onCancel() {
      this.$v.$reset();
      this.attributes = Object.assign({}, this.defaultForm);
      this.attributes.rules = [{ column: 'tag', relation: '', condition: null }];
      this.$forceUpdate();
      //website.collections
    },
    async onSubmit() {
      this.$v.$touch();
      utilities.scrollToTop();
      const isErrosCondition =
        this.attributes && this.attributes.rules ? this.attributes.rules.find(item => item.relation === '') : false;
      try {
        if (!this.$v.$invalid && !isErrosCondition) {
          this.errors = [];
          this.isLoading = true;
          if (this.attributes && !this.attributes.published) {
            this.attributes.published = false;
          }
          let convertData = {
            ...this.attributes,
            rules: this.attributes.collectionType === 'normal' ? null : this.attributes.rules,
          };
          await gmcApi.updateSyncCollection(this.idItem, convertData);
          this.isLoading = true;
          // this.attributes.menuCollection
          console.log('this.menuCollection', this.menuCollection);
          try {
            for (let i = 0; i < this.menus.length; i++) {
              let mWm = this.menuCollection.find(menu => this.menus[i].id === menu.id);
              console.log(`mWm`, mWm);
              if (mWm) {
                await menuService.updateMenuForCollection(mWm.id, this.idItem);
              } else {
                await menuService.deleteMenuForCollection(this.menus[i].id, this.idItem);
                //remove
              }
            }
          } catch (error) {
            console.log('error', error);
          }

          // window.location.reload();
        } else {
          this.errors = ['Validate rule error'];
        }
      } catch (error) {
        this.isLoading = false;
      }
      this.isLoading = false;
    },
  },
  watch: {
    attributes: {
      handler: function(val, oldVal) {
        this.showHeader = !utilities.comparisonTwoObject(this.defaultForm, this.attributes);
      },
      deep: true,
    },
    selected: function() {},
    checkAll: function(val) {
      if (!this.checkAll) this.selected = [];
      else {
        this.productList.map(product => {
          if (!this.selected.includes(product._id)) this.selected.push(product._id);
        });
      }
    },
  },
  computed: {},
  validations: {
    attributes: {
      title: {
        required,
      },
      metaDescription: {
        maxLength: maxLength(160),
      },
      rules: {
        $each: {
          condition: { required },
          column: { required },
          relation: { required },
        },
      },
    },
  },
};
</script>
<style lang="scss">
.product-page--create {
  .btn-link {
    color: var(--v-primary-base);
    &:hover {
      text-decoration: none;
    }
  }
  .v-expansion-panel:before {
    box-shadow: none;
  }
  .v-expansion-panel-header__icon {
    position: absolute;
    right: 20px;
    top: 20px;
  }
  .list-product {
    max-height: 500px;
    overflow: auto;
    padding-left: 0;
    list-style: none;
    li {
      display: block;
    }
  }

  .action-box {
    border-radius: 10px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    padding-left: 8px;
    padding-right: 8px;
  }

  .cb-nocss {
    margin-top: 0px;
    padding: 10px;
  }

  .btn-action {
  }
}
</style>
